module.exports = __webpack_public_path__ + "static/media/data_light.66b490e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/data_light.png
// module id = 3539
// module chunks = 3